import { DataBox, createDataBox } from 'app/common/data-box-store'


type AcquiringSettingsParams = {}
const defaultAcquiringSettingsParams: AcquiringSettingsParams = {}

class AcquiringSettingsParamsDataBox extends DataBox<AcquiringSettingsParams> { }
export const acquiringSettingsParams = createDataBox(
  'acquiringSettingsParams',
  defaultAcquiringSettingsParams,
  AcquiringSettingsParamsDataBox
)
